<template>
    <div>
        <div class="tv-nav">
            <div class="logo">
                <img :src="logo" @click="toHome()"/>
            </div>
        </div>
        <div class="about-app-inset">
            <image-bg 
                :title="'Purchase Device'" 
                :min-title="'おすすめ利用端末'"
                :bg-images="banner"
            ></image-bg>
            <div class="msg-area">
                <div class="goods-list">
                    <div class="goods" v-for="(n, index) in goodsList" :key="index">
                        <img :src="n.imageUrl" />
                        <div class="to-buy-btn" @click="toUrl(n.linkUrl)">
                            購入
                        </div>
                    </div>
                </div>
            </div>
            <tv-footer></tv-footer>
        </div>
    </div>
</template>
<script>
import imageBg from '../../components/image-bg'
import tvFooter from '../home/modules/footer'
import { banner, goodsList } from './images/index'
import logo from '../../images/logo.png'
import publicMinxin from '../public-minxin'
export default {
    mixins: [publicMinxin],
    components: {
        imageBg,
        tvFooter
    },
    data () {
        return {
            banner,
            logo,
            goodsList
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {

        },
        toUrl (url) {
            location.href = url
        }
    }
}
</script>
<style scoped>
.about-app-inset {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 60px;
}
.msg-area {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 20px;
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
}
.tv-nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    z-index: 999;
    border-bottom: solid 2px  #D1D1D1;;
}
.logo img {
    display: block;
    height: 100%;
}
.goods-list {
    display: block;
    width: 100%;
    box-sizing: border-box;
}
.goods {
    width: 50%;
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
    padding: 5px;
}
.goods img {
    display: block;
    width: 100%;
}
.goods-list .goods .to-buy-btn {
    width: 100px;
    height: 30px;
    margin: 0 auto;
    margin-top: 15px;
    margin-bottom: 10px;
    border-radius: 30px;
    border:solid 1px #FDB819;
    color: #000;
    line-height: 30px;
}
.goods-list .goods .to-buy-btn:active {
    background-color:  #FDB819;
    color:#fff
}
</style>